'use strict';

angular.module('app.services').factory('chamadosApi', chamadosApi);

chamadosApi.$inject = ['$resource', 'ConfigApp'];

function chamadosApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/chamados',
        {}, {
            abrirChamado: {
                method: 'POST',
                url: ConfigApp.UrlApi + '/v1.0/chamados',
                headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' }
            },
            detalhesChamado: {
                method: 'GET',
                isArray: false,
                url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/por_usuario'
            },
            unidades: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/unidades',
                ignoreLoadingBar: true,
                cache: true
            },
            responderAoAtendente: {
                method: 'POST',
                url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagem_ao_atendente',
                params: { chamadoId: '@chamadoId' },
                headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' }
            }
        });
};


// WEBPACK FOOTER //
// ./src/services/chamado-api-service.js